import React from 'react';

/**
 * The heading of the parent-facing comments (v3.96.0) — shared by the student
 * pop-up and the /teacher-report page. On screen it reads "Comments for
 * families", with "Printed on the report that goes home." under it, so it is
 * never mistaken for the Teacher notes (screen-only) below. On paper the
 * heading is unchanged: "Teacher Comments". Each page's print CSS shows
 * `.print-only-heading` (display: inline !important) and hides `.no-print`.
 */
export const FAMILY_COMMENTS_SCREEN_TITLE = 'Comments for families';
export const FAMILY_COMMENTS_PRINT_TITLE = 'Teacher Comments';
export const FAMILY_COMMENTS_PRINTED_HINT = 'Printed on the report that goes home.';

function FamilyCommentsHeading({ className, style, hintClassName, hintStyle }) {
  return (
    <>
      <h3 className={className} style={style}>
        <span className="no-print">{FAMILY_COMMENTS_SCREEN_TITLE}</span>
        <span className="print-only-heading" style={{ display: 'none' }}>{FAMILY_COMMENTS_PRINT_TITLE}</span>
      </h3>
      <p className={`no-print${hintClassName ? ` ${hintClassName}` : ''}`} style={hintStyle}>{FAMILY_COMMENTS_PRINTED_HINT}</p>
    </>
  );
}

export default FamilyCommentsHeading;
